import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { EmailactivationService } from './emailactivation.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'ngx-alerts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-emailactivation',
  templateUrl: './emailactivation.component.html',
  styleUrls: ['./emailactivation.component.css']
})
export class EmailactivationComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService, private activatedRoute: ActivatedRoute, private emailactivationService: EmailactivationService, private routes: Router, private alertService: AlertService) { }

  ngOnInit() {
    let code = this.activatedRoute.snapshot.queryParams["st"];
    if(code) {
        this.spinner.show();
        this.emailactivationService.check(code).then((res: any) => {
          this.spinner.hide();
          this.alertService.success(res.message);
          this.routes.navigate(['/login']);
          }).catch((err: any)  => { this.alertService.danger(err.message)
            this.spinner.hide();
            this.routes.navigate(['/login']);
          });
    }
  }

}
